<template>
  <div class="container-fluid p-0 m-0">
    <div class="row m-0 p-0">
      <div class="col m-0 p-0">
        <nav
          class="navbar navbar-expand-md rounded-bottom sticky-top"
          :class="{ 'navbar-dark-bg': mobileTogglerClicked && isMobile }"
        >
          <div class="container-fluid">
            <a class="navbar-brand" @click="goToHome">
              <img src="/assets/logo.png" alt="Logo Paragliding Rome" width="115" />
            </a>
            <button
              class="navbar-toggler"
              @click="collapsedNavbarHandler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbar_elements"
              aria-controls="navbar_elements"
              aria-label="Toggle navigation"
            >
              <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbar_elements">
              <ul class="navbar-nav me-auto mt-1">
                <li class="nav-item d-flex justify-content-center">
                  <a class="nav-link" @click="goToHome">Home</a>
                </li>
                <li class="nav-item d-flex justify-content-center">
                  <a class="nav-link" @click="navigateAndScroll('safety')">Safety</a>
                </li>
                <li class="nav-item d-flex justify-content-center">
                  <a class="nav-link" @click="navigateAndScroll('places')">Places</a>
                </li>
                <li class="nav-item d-flex justify-content-center">
                  <a class="nav-link" @click="navigateAndScroll('contacts')">Contacts</a>
                </li>
                <li class="nav-item d-flex justify-content-center">
                  <a class="nav-link" @click="goToBook">Book experience</a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mobileTogglerClicked: false,
      isMobile: false,
    };
  },
  props: {
    page: Number,
  },
  mounted() {
    this.checkIfMobile();
    window.addEventListener("resize", this.checkIfMobile);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkIfMobile);
  },
  methods: {
    checkIfMobile() {
      this.isMobile = window.innerWidth <= 767;
    },
    collapsedNavbarHandler() {
      this.mobileTogglerClicked = !this.mobileTogglerClicked;
      this.checkIfMobile();
    },
    goToHome() {
      this.$emit("emitPageChange", { page: 'home' });
      this.collapseNavbar();
    },
    goToBook() {
      this.$emit("emitPageChange", { page: 'book' });
      this.collapseNavbar();
    },
    scrollTo(sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
    navigateAndScroll(sectionId) {
      if (this.page !== 'home') {
        this.$emit("emitPageChange", { page: 'home' });
        this.$nextTick(() => {
          setTimeout(() => {
            this.scrollTo(sectionId);
          }, 300);
        });
      } else {
        this.scrollTo(sectionId);
      }
      this.collapseNavbar();
    },
    collapseNavbar() {
      const navbarCollapse = document.getElementById('navbar_elements');
      if (navbarCollapse && navbarCollapse.classList.contains('show')) {
        const collapseInstance = window.bootstrap.Collapse.getInstance(navbarCollapse);
        if (collapseInstance) {
          collapseInstance.hide();
        }
      }
      this.mobileTogglerClicked = false; // reset state when collapsed
    }
  }
}
</script>

<style scoped>
.nav-item:hover {
  cursor: pointer;
}

.navbar {
  position: absolute;
  width: 100%;
  z-index: 990;
  background: transparent;
  transition: background-color 0.3s ease;
}

.nav-link{
  color: white;
}

.navbar-toggler {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(255,255,255,0.95)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E");
}

.navbar-dark-bg {
  background-color: rgba(0, 0, 0, 0.85) !important;
}
</style>
